import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { VtmnPlayIconButtonSizeEnum } from './enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from './enum/vtmn-play-icon-button-variant.enum';
import { VtmnPlayIconButtonVariantStyleEnum } from './enum/vtmn-play-icon-button-variant-style.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';

@Component({
  selector: 'button[app-vtmn-play-icon-button], a[app-vtmn-play-icon-button]',
  templateUrl: './vtmn-play-icon-button.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class VtmnPlayIconButtonComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('class') public elementClasses = '';
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('ngClass') public ngClass = '';
  @Input() public size? = VtmnPlayIconButtonSizeEnum.MEDIUM;
  @Input() public variant? = VtmnPlayIconButtonVariantEnum.PRIMARY;
  @Input() public style? = VtmnPlayIconButtonVariantStyleEnum.REGULAR;
  @Input() public type? = CtaButtonTypeEnum.Button;

  @HostBinding('class')
  public get className(): string {
    const classes = [
      // eslint-disable-next-line max-len
      `${this.elementClasses} ${this.ngClass} vp-icon-button vp-icon-button--${this.size} vp-icon-button--${this.variant} vp-icon-button--${this.style}`,
    ];

    return classes.join(' ');
  }
}
